import {
  Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer, ViewChild, Injector } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { RiderService } from '../../rider.service';
import { GridOptions } from 'ag-grid';
import { VehiclesService } from '../../../vehicles/vehicles.service';
import { constant } from '../../../../app.constants';
import { DriversService } from '../../../drivers/drivers.service';
import {T2CardComponent} from '../../../../trip2-theme/components/t2-card/t2-card.component';
import {BooleanCheckComponent} from '../../../A2-utils/grid-components/boolean-check/boolean-check.component';
import { ParentModule } from 'app/pages/A2-utils/ParentClass/parent-module';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { UsersService } from 'app/pages/users/users.service';
import { BooleanCheckDisabledComponent } from 'app/pages/A2-utils/grid-components/boolean-check-disabled/boolean-check-disabled.component';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

declare var jQuery: any;

@Component({
  selector: 'app-riders-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss']
})
export class CreateComponent extends ParentModule implements OnInit {
  public currentUser: any = JSON.parse(localStorage.getItem('currentUser'));
  protected addPayorRiderModalVisible = false;
  protected addMergeAccountModal = false;
  protected activeIVRTab = 0;
  protected mask                    = constant.MASK_PHONE;
  protected maskSSN                 = constant.MASK_SSN;
  public  riderPayorsArray        =  [];
  protected riderForm: FormGroup;
  private gridRiderPayor: GridOptions;
  private isRiderHistory= true;
  private isMobileApp= true;
  private isLocation= true;
  private isLocationp= true;
  private residence_type= 'Location';
  private residence_typeP= 'Location';
  protected permanentResidence= false;
  private isRiderCreateModal= false;
  private isIVRChecked= false;
  private isIvrVisible= false;
  private isRiderDetails= false;
  private isContentRiderVisible= false;
  private isNoteRiderVisible= true;
  private activeClass= 0;
  private callTypes: any;
  public payorId: number;
  private rndRiderPayorId= 0;
  public riderID: number;
  public  maskDate= [/[0-1]/, /[0-9]/, '-', /[0-3]/, /[0-9]/, '-', /[1-2]/, /[0-9]/, /[0-9]/, /[0-9]/];
  // public myDatePickeOptions: IMyOptions = {
  //     dateFormat: 'mm-dd-yyyy',
  //     editableDateField: false
  // };
  private riderPayorData: any;
  private payorInlist= [];

  private riderMergeArray: any[];
  private drivers: any[];
  protected providers = [];

  /**
   * rules var
   */
  _rules: any;
  showModule = false;
  loadingModule = true;
  onChangeRules = false;
  /// end

  protected location = {
    streetaddress : '',
    city          : '',
    state         : '',
    zip           : '',
    latitude      : '',
    longitude     : '',
    location      : '',
    county        : '',
    roomaptnumber : ''
  };
  protected locationP = {
    streetaddress : '',
    city          : '',
    state         : '',
    zip           : '',
    latitude      : '',
    longitude     : '',
    location      : '',
    county        : '',
    roomaptnumber : ''
  };
  appSearchlocationRripTouched: boolean;
  pAppSearchlocationRripTouched: boolean;

  @Input() riderId: any;
  @Output() riderFullName: EventEmitter<any>= new EventEmitter<any>();
  @Output() closeRiderForm: EventEmitter<any>= new EventEmitter<any>();
  @Output() titleRider?: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('addPayorRiderModal') addPayorRiderModal: T2CardComponent;
  @ViewChild('permanentCheck') pcheck: ElementRef;
  @ViewChild('ivr') ivr: ElementRef;
  @ViewChild('contentRider') contentRider: ElementRef;
  @ViewChild('notesRider') notesRider: ElementRef;
  @ViewChild('containerLinkTabs') containerLinkTabs: ElementRef;
  @ViewChild('sendSms') sendSms: ElementRef;
  @ViewChild('mergeAccountModal') riderDuplicatedModal: T2CardComponent;
  datasTem: any = {};

  constructor(
    private fb: FormBuilder,
    private riderService: RiderService,
    private callTypeService: VehiclesService,
    private renderer: Renderer,
    protected driverService: DriversService,
    protected Inject: Injector,
    protected _loading: T2LoadingService,
    protected userService: UsersService,
    private toastrAlertHelper: ToastrAlertHelper,
    private sweetAlertHelper: SweetAlertHelper
  ) {
    super('app-riders-create', Inject);
  }

  ngOnInit() {
    this.getProviders();
    this.callTypeService.getCallType().subscribe(
      data => {
        this.callTypes = data;
      }
    );
    this.createRiderForm();

    this.applyRulesForm();
    const self = this;
    this.gridRiderPayor = <GridOptions>{};
    this.gridRiderPayor.enableColResize = true;
    this.gridRiderPayor.enableFilter    = true;
    this.gridRiderPayor.rowSelection    = 'single';
    this.gridRiderPayor.columnDefs      = this.createColumnDefs();
    this.gridRiderPayor.onGridReady     = (data) => {
      self.gridRiderPayor.api.sizeColumnsToFit();
    };
    if ( this.riderId !== 0 ) {
      this.isRiderDetails = true;
      setTimeout(() => {
        this.loadDataRider();
      }, 800);
    }else {
      this.isRiderDetails = false;
      setTimeout(() => {
        this.titleRider.emit('New Rider');
      }, 800);

    }
  }

  onRiderKeepEmit(event) {
    this.riderId = event;
    this.loadDataRider();
  }
  loadDataRider() {
    this._loading.show();
    this.riderService.getRider(this.riderId, true)
      .finally(() => {
        this._loading.hiden();
    }).subscribe(
      data => {
        this.assignDataToModel(data);
        this.datasTem = data;
        this.titleRider.emit('Edit ' + data.fullname.replace(',',''));
        this.loadPayorsGrid(data);
      }
    );
  }

  private getDrivers(providerid) {
    this.driverService.getDriversProviderAllByProvider(providerid).subscribe(
      data => this.drivers = data
    );
  }
  loadPayorsGrid(data) {

    this.riderPayorsArray = data.riderpayors.map(
      (payor: any ) => {
        payor['payordescription'] = payor.payor.description;
        payor.expirationdate = (payor.expirationdateformatted) ? payor.expirationdateformatted : '';
        payor.startdate = (payor.startdateformatted) ? payor.startdateformatted : '' ;
        return payor;
      }
    );

    const payorDefault = this.riderPayorsArray.filter((riderpayor) => {
      return riderpayor.isdefault;
    })
    if (payorDefault.length > 0) {
      this.getRulesByPayor(payorDefault[0].payor.payorid);
    }

    // this.gridRiderPayor.onGridReady = () => {
    //   this.gridRiderPayor.api.setRowData(this.riderPayorsArray);
    //   this.gridRiderPayor.api.sizeColumnsToFit();
    // };

      this.gridRiderPayor.api.setRowData(this.riderPayorsArray);

    // this.gridRiderPayor.api.sizeColumnsToFit();

    /*if (this.gridRiderPayor) {
      if (this.gridRiderPayor.api) {
        this.gridRiderPayor.api.setRowData(this.riderPayorsArray);
        this.gridRiderPayor.api.sizeColumnsToFit();
      }
    }*/
  }
  assignDataToModel(data) {
    this.riderFullName.emit('Edit Rider: ' + data.fullname);
    this.onClickOptOff(data.ivrstatus);
    this.riderForm.patchValue({
      _roleid: this.currentUser.roleid,
      _permatentResidence  :   data.permanentCheck,
      riderid         :   data.riderid,
      fullname        :   data.fullname,
      firstname       :   data.firstname,
      middleinitial   :   data.middleinitial,
      lastname        :   data.lastname,
      ssn             :   data.ssn,
      dob             :   data.dobformatted,
      streetaddress   :   data.streetaddress,
      location        :   data.location,
      roomaptnumber   :   data.roomaptnumber,
      city            :   data.city,
      state           :   data.state,
      zip             :   data.zip,
      phonenumber     :   data.phonenumber,
      email           :   data.email,
      gender          :   data.gender,
      latitude        :   data.latitude,
      longitude       :   data.longitude,
      isvip           :   data.isvip,
      providerid      : data.providerid,
      isfacility              : data.isfacility,
      alternatephonenumber    : data.alternatephonenumber,
      calltypeid              : data.calltypeid,
      defaultpayor            : data.defaultpayor,
      defaultpayorid          : data.defaultpayorid,
      policy                  : data.policy,
      dobformatted            : data.dobformatted,
      address                 : data.address,
      sendsms                 : data.sendsms,
      sendmail                : data.sendmail,
      makephonecall           : data.makephonecall,
      preferredlanguage       : data.preferredlanguage,
      plocation               : data.plocation,
      pstreetaddress          : data.pstreetaddress,
      proomaptnumber          : data.proomaptnumber,
      pcity                   : data.pcity,
      pstate                  : data.pstate,
      pzip                    : data.pzip,
      pphonenumber            : data.pphonenumber,
      platitude               : data.platitude,
      plongitude              : data.plongitude,
      driverid                : data.driverid,
      county                  : data.county,
      pcounty                 : data.pcounty,

    });

    this.location = {
      streetaddress : data.streetaddress,
      city          : data.city,
      state         : data.state,
      zip           : data.zip,
      latitude      : data.latitude,
      longitude     : data.longitude,
      location      : data.location,
      county        : data.county,
      roomaptnumber : data.roomaptnumber
    };

    this.locationP = {
      streetaddress : data.pstreetaddress,
      city          : data.pcity,
      state         : data.pstate,
      zip           : data.pzip,
      latitude      : data.platitude,
      longitude     : data.plongitude,
      location      : data.plocation,
      county        : data.pcounty,
      roomaptnumber : data.proomaptnumber
    };

    if  (data.plocation !== '' && data.plocation !== undefined) {
      this.permanentResidence = true;
      this.renderer.setElementAttribute(this.pcheck.nativeElement, 'checked', `${this.permanentResidence}`);
    }
    // this.riderForm.setValue(data);
    const providerid = this.riderForm.get('providerid').value;
    if (providerid) {
      this.getDrivers(providerid);
    }
  }


  changePermanent() {
    this.permanentResidence = !this.permanentResidence;
    this.riderForm.patchValue({_permatentResidence: this.permanentResidence});
    this.riderForm.updateValueAndValidity();
    this.renderer.setElementAttribute(this.pcheck.nativeElement, 'checked', `${this.permanentResidence}`);
  }


  createRiderForm() {
    this.riderForm =  this.fb.group({
      _roleid: this.currentUser.roleid,
      _permatentResidence     : [false],
      _activeIVRTab           : [''],
      _selectedDefaultPayor   : [''],
      riderid                 : [''],
      fullname                : [''],
      firstname               : [''],
      middleinitial           : [''],
      lastname                : [''],
      ssn                     : [''],
      dob                     : [''],
      streetaddress           : [''],
      location                : [''],
      roomaptnumber           : [''],
      city                    : [''],
      state                   : [''],
      zip                     : [''],
      phonenumber             : [''],
      email                   : [''],
      gender                  : [''],
      latitude                : [''],
      longitude               : [''],
      isvip                   : [''],
      isinactive              : [''],
      ivrstatus               : [0],
      sendsms                 : [''],
      sendmail                : [''],
      makephonecall           : [''],
      preferredlanguage       : [''],
      county                  : [''],
      providerid              : [''],

      // PLACE RIDERPAYORS JSON HERE

      isfacility              : [''],
      alternatephonenumber    : [''],
      calltypeid              : [''],
      defaultpayor            : [''],
      defaultpayorid          : [''],
      policy                  : [''],
      dobformatted            : [''],
      address                 : [''],
      addedon                 : [''],
      modifiedon              : [''],
      plocation               : [''],
      pstreetaddress          : [''],
      proomaptnumber          : [''],
      pcity                   : [''],
      pstate                  : [''],
      pzip                    : [''],
      pphonenumber            : [''],
      platitude               : [''],
      plongitude              : [''],
      driverid                : [''],
      pcounty                 : [''],
    });
    this.disableInputs();
  }

  changeLocationTypeRider() {
    this.isLocation = !this.isLocation;
    if (this.isLocation) {
      this.residence_type = 'Location';
    }else {
      this.residence_type = 'Facility';
    }
  }

  changeLocationTypeRiderP() {
    this.isLocationp = !this.isLocationp;
    if (this.isLocationp) {
      this.residence_typeP = 'Location';
    }else {
      this.residence_typeP = 'Facility';
    }
  }

  loadLocationP(resp: any) {
    this.riderForm.patchValue({
      pstreetaddress : resp.streetaddress,
      pcity          : resp.city ,
      pstate         : resp.state,
      pzip           : resp.zip,
      platitude      : resp.latitude,
      plongitude     : resp.longitude,
      plocation      : resp.location,
      pcounty         : resp.county,
      proomaptnumber : resp.roomaptnumber
    });

  }

  loadLocation(resp: any) {
    this.riderForm.patchValue({
      streetaddress : resp.streetaddress,
      city          : resp.city ,
      state         : resp.state,
      zip           : resp.postal_code,
      latitude      : resp.latitude,
      longitude     : resp.longitude,
      location      : resp.location
    });
  }

  onSelectFacility(event) {
    this.riderForm.patchValue({
      location      :   event.locationName,
      streetaddress :   event.street_number,
      roomaptnumber :   event.roomaptnumber,
      city          :   event.locality,
      state         :   event.administrative_area_level_1,
      zip           :   event.postal_code,
      phonenumber   :   event.phonenumber,
      latitude      :   event.latitude,
      longitude     :   event.longitude,
    });
  }

  disableInputs() {
    // this.riderForm.get('city').disable();
    // this.riderForm.get('state').disable();
    // this.riderForm.get('zip').disable();
    // this.riderForm.get('pcity').disable();
    // this.riderForm.get('pstate').disable();
    // this.riderForm.get('pzip').disable();
    // this.riderForm.get('pstreetaddress').disable();
    // this.riderForm.get('plocation').disable();
  }

  onPermanentResidenceInfo() {
    this.permanentResidence = !this.permanentResidence;
  }

  submiNewRiderForm(values, event) {
    if (this.onChangeCheck()) {
      this.toastrAlertHelper.info('Please select at least one option of ivr Opt-in');
    }else {
      const riderpayors = [];

      this.gridRiderPayor.api.forEachNode(
        data => {
          delete data.data.plan;
          riderpayors.push(data.data);
        }
      );
      values['riderpayors'] = riderpayors;
      if (riderpayors.length !== 0 && this.validatePayorDefault(riderpayors)) {

        const tmpRiderPayor = JSON.parse(JSON.stringify(riderpayors));
        const putRiderPayors = tmpRiderPayor.map((riderPayor) => {
          delete riderPayor.addedon;
          delete riderPayor.modifiedon;
          delete riderPayor.payor;
          delete riderPayor.payordescription;
          delete riderPayor.lineofbusiness;
          if (riderPayor.riderpayorid < 0) {
            delete riderPayor.riderpayorid;
          }
          riderPayor.riderid = this.riderId;
          return riderPayor;
        });
        values['riderpayors'] = putRiderPayors;
        if (this.riderId === 0) {
          this.riderService.postData(values).subscribe(
            data => {
              this.toastrAlertHelper.success(data.message);
              this.closeRiderForm.emit(data);
            },
            (error) => {
              this.handleError(error);
            }
          );
        } else {

          this.riderService.putData(values).subscribe(
            data => {
              this.toastrAlertHelper.success(data.message);
              data['data'] = this.riderId;
              this.closeRiderForm.emit(data);
            },
            (error) => {
              this.sweetAlertHelper.createCustomAlert({title: 'Error', text: error.message, type: 'error'});
              this.toastrAlertHelper.error(error.message);
              this.handleError(error);
            }
          );
        }
      } else {
        this.sweetAlertHelper.createCustomAlert({text: 'Please add a Payor by default to save the form'});
      }
    }
  }

  private validatePayorDefault(riderpayors) {
    const filter = riderpayors.filter(riderpayor => riderpayor.isdefault);
    return filter.length !== 0;
  }

  private handleError(error) {
    if (error.message.charAt(0) === '[') {
      this.riderMergeArray = JSON.parse(error.message);
      this.riderDuplicatedModal.open();
    } else {
      this.sweetAlertHelper.createCustomAlert({title: 'Error', text: error.message, type: 'error'});
    }
  }

  addNewPayor_Modal() {
    this.rndRiderPayorId--;
    this.riderPayorData = null;
    this.payorInlist = this.getPayorsId();
    this.isRiderCreateModal = true;
    this.addPayorRiderModal.open();
  }
  private createColumnDefs() {
    return [
      {
        cellClass: 't2-cursorPointer textAlignCenter',
        headerName: 'Def',
        field: 'isdefault',
        colId: 'isdefault',
        width: 50,
        cellRendererFramework: BooleanCheckComponent,
        onCellClicked: (params) => {

          const index = params.node.childIndex;
          params.api.forEachNode((node) => {
            if (node.childIndex === index) {
              node.data.isdefault = true;
              this.getRulesByPayor(node.data.payor.payorid);
            }else {
              node.data.isdefault = false;
            }
          });
          params.api.refreshView();

        }
      },
      {
        headerName: 'Payor',
        field: 'payordescription',
        colId: 'square',
        width: 150
      },
      {
        headerName: 'Policy',
        field: 'memberid',
        colId: 'cube',
        width: 90
      },
      {
        headerName: 'Group',
        field: 'groupid',
        colId: 'group',
        width: 90,
      },
      {
        headerName: 'Start Date',
        field: 'startdate',
        colId: 'startdate',
        width: 70
      },
      {
        headerName: 'End Date',
        field: 'expirationdate',
        colId: 'expirationdate',
        width: 70
      },
      {
        headerName: 'Active',
        field: 'isactive',
        colId: 'isactive',
        width: 60,
        cellRendererFramework: BooleanCheckComponent,
      },
      {
        headerName: 'LTC',
        field: 'isltc',
        colId: 'isltc',
        width: 60,
        cellRendererFramework: BooleanCheckComponent,
      },
      {
        headerName: 'DUAL',
        field: 'plan.isdual',
        colId: 'isdual',
        width: 80,
        cellRendererFramework: BooleanCheckDisabledComponent,
      }
    ];
  }
  onEmitRiderPayorForm(dataObject) {
    this.onCloseRiderPayorModal();
    this.updateRiderPayorArray(dataObject);

  }

  updateRiderPayorArray(data) {
    if (this.riderPayorsArray.length > 0) {
      let isNew = true;
      const arrayRefactory = this.riderPayorsArray.map(function(item){
        if (item.riderpayorid === data.riderpayorid) {
          item.payorid          =   data.payorid;
          item.payordescription =   data.payordescription;
          item.isdefault        =   data.isdefault;
          item.memberid         =   data.memberid;
          item.groupid          =   data.groupid;
          item.planid           =   data.planid;
          item.isactive         =   data.isactive;
          item.expirationdate   =   data.expirationdate;
          item.startdate        =   data.startdate;
          item.lineofbusiness   =   data.lineofbusiness;
          isNew = false;
        }else {
          if (data.isdefault) {
            item.isdefault = false;
          }
        }
        return item;
      });
      if (isNew) {
        arrayRefactory.push(data);
      }
      this.riderPayorsArray = arrayRefactory;

    }else {
      this.riderPayorsArray.push(data);
    }

    const payorDefault = this.riderPayorsArray.filter((riderpayor) => {
      return riderpayor.isdefault;
    })

    if(payorDefault.length > 0) {
      this.getRulesByPayor(payorDefault[0].payor.payorid);
    }

    if (this.gridRiderPayor) {
      if (this.gridRiderPayor.api) {
        // this.gridRiderPayor.onGridReady = () => {
        //   this.gridRiderPayor.api.setRowData(this.riderPayorsArray);
        //   this.gridRiderPayor.api.sizeColumnsToFit();
        // };
        this.gridRiderPayor.api.setRowData(this.riderPayorsArray);
        this.gridRiderPayor.api.sizeColumnsToFit();
      }
    }

  }

  private getRulesByPayor(payorid) {
    this.riderForm.patchValue({_selectedDefaultPayor: payorid})
    this.getActionsForPayor(payorid);
  }

  onDoubleClickRiderPayor(event) {
    this.riderPayorData = event.data;
    this.isRiderCreateModal = true;
    this.addPayorRiderModal.open();
    this.payorInlist = this.getPayorsId(event.data.payorid);


  }

  getPayorsId(skipId?) {
    const payorsId = this.riderPayorsArray.map((item) => {
      if (item.payorid !== skipId ) {
        return item.payorid;
      }
    });
    return payorsId;

  }

  close() {
    this.closeRiderForm.emit(true);

  }

  onCloseRiderPayorModal() {
    this.addPayorRiderModal.close();
    this.isRiderCreateModal = false;
  }

  public deletePayor() {
    const selectedNodes = this.gridRiderPayor.api.getSelectedNodes();
    this.gridRiderPayor.api.removeItems(selectedNodes);

    const riderpayorid = selectedNodes[0].data.riderpayorid;
    const filterSelected = this.riderPayorsArray.filter((riderpayor) => {
      return riderpayor.riderpayorid !== riderpayorid;
    });

    this.riderPayorsArray = filterSelected;
  }
  public onChangeIvr(event) {
    this.isIVRChecked = !this.isIVRChecked;
    this.renderer.setElementAttribute(this.ivr.nativeElement, 'checked', `${true}`);
  }
  onChangeCheck() {
    if (this.riderForm.get('ivrstatus').value === 2 || this.riderForm.get('ivrstatus').value === 0) {
      return false;
    }else {
      if (this.riderForm.get('sendmail').value || this.riderForm.get('sendsms').value || this.riderForm.get('makephonecall').value) {
        return false;
      }else {
        return true;
      }
    }
  }
  ivrCheck(event, ivrCheck) {
    if (event) {
      // this.riderForm.get('sendsms').clearValidators();
      // this.riderForm.get('sendsms').updateValueAndValidity();
      // this.riderForm.get('sendmail').clearValidators();
      // this.riderForm.get('sendmail').updateValueAndValidity();
      // this.riderForm.get('makephonecall').clearValidators();
      // this.riderForm.get('makephonecall').updateValueAndValidity();
    }
  }
  onClickOptIn(value) {
    this.disableEnableIvrOptions(value);
    this.riderForm.patchValue({
      ivrstatus: value
    });
    jQuery('.switch').removeClass('optNull');
    jQuery('.switch').removeClass('optOut');
    jQuery('.switch').addClass('optIn');
    jQuery('.switch').stop().animate({
      left: 0,
    }, 300);
  }
  onClickNone(value) {
    this.disableEnableIvrOptions(value);
    this.riderForm.patchValue({
      ivrstatus: value
    });
    jQuery('.switch').removeClass('optIn');
    jQuery('.switch').removeClass('optOut');
    jQuery('.switch').addClass('optNull');
    jQuery('.switch').stop().animate({
      left: 50
    }, 300);
  }
  onClickOptOff(value) {
    this.disableEnableIvrOptions(value);
    this.riderForm.patchValue({
      ivrstatus: value,
      sendsms: false,
      sendmail: false,
      makephonecall: false,
      preferredlanguage: null,
    });
    jQuery('.switch').removeClass('optIn');
    jQuery('.switch').removeClass('optNull');
    jQuery('.switch').addClass('optOut');
    jQuery('.switch').stop().animate({
      left: 100,
    }, 300);
  }
  disableEnableIvrOptions(value) {
    this.activeIVRTab = value;
    this.riderForm.patchValue({_activeIVRTab: value});

    if ( value === 0) {
      this.isIvrVisible = false;
    }else {
      this.isIvrVisible = true;
    }
  }
  onChangeRiderDetail(event) {
    this.activeClass = event;
    switch (event) {
      case 0:
        this.isContentRiderVisible  = false;
        this.isNoteRiderVisible     = true;
        this.isRiderHistory         = true;
        this.isMobileApp            = true;
        break;
      case 1:
        this.isContentRiderVisible  = true;
        this.isNoteRiderVisible     = false;
        this.isRiderHistory         = true;
        this.isMobileApp            = true;
        break;
      case 2:
        this.isContentRiderVisible  = true;
        this.isNoteRiderVisible     = true;
        this.isRiderHistory         = false;
        this.isMobileApp            = true;
        break;
      case 3:
        this.isContentRiderVisible  = true;
        this.isNoteRiderVisible     = true;
        this.isRiderHistory         = true;
        this.isMobileApp            = false;
        break;

      default:
    }
  }

  onSearchLocationTrip(params) {
    this.riderForm.patchValue({
      streetaddress : params.streetaddress,
      city          : params.city,
      state         : params.state,
      zip           : params.zip,
      latitude      : params.latitude,
      longitude     : params.longitude,
      location      : params.location,
      county        : params.county,
      roomaptnumber : params.roomaptnumber
    });

  }

  // RULEs

  applyRulesForm () {
    if (this.loadingModule) {
      this.loadingModule = false;
      this._loading.hiden();
    }

    if (this.onChangeRules) {
      this._loading.hiden();
      this.onChangeRules = false;
    }

    if (this.riderForm) {
      this.applyRules(this.riderForm, this.riderId !== 0 ? 'Update' : 'Create');

    }
  }

  getProviders() {
    this.userService.getAllProviders().subscribe(
      provs => {
        this.providers = provs;
      }
    )
  }

  /**
   * this execute when use change provider
   */
  onChangeProvider() {
    this.riderForm.patchValue({driverid: ''});
    const providerid = this.riderForm.get('providerid').value;
    if (providerid) {
      this.getDrivers(providerid);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/riders/components/create/create.component.ts